import React from 'react';
import IconoAsesora from '../../../../icons/callcenter.png';
import '../../styles/coberturaNacional/tarjetaestado.css';

const TarjetaEstado = ({ estado, tipo, name, telefonos }) => {
  const esVentas = name === 'Ventas';
  const nombresSeparados =
    !esVentas && name && name.includes('/') ? name.split('/') : [];

  // Formatear "Asesores de venta" en dos líneas
  const textoTipo =
    tipo === 'Asesores de venta' ? (
      <>
        Asesores
        <br />
        de venta
      </>
    ) : (
      tipo
    );
  return (
    <div className="tarjeta-estado">
      <div className="tarjeta-icono">
        <img src={IconoAsesora} loading="lazy" alt="Asesor" />
      </div>
      <div className="tarjeta-info">
        <p className="tarjeta-estado-nombre">{estado}</p>
        <h3 className="tarjeta-titulo">{textoTipo}</h3>

        {/* Si es "Ventas", mostrar todos los teléfonos juntos */}
        {esVentas && telefonos && (
          <p className="tarjeta-telefonos">
            <span className="bold-tarjeta-estado">Ventas:</span>{' '}
            {telefonos.join('/')}
          </p>
        )}

        {/* Si hay varios asesores */}
        {!esVentas && nombresSeparados.length > 0 && telefonos && (
          <div className="tarjeta-listado">
            {nombresSeparados.map((nombre, index) => (
              <p key={index} className="tarjeta-nombre">
                <span className="bold-tarjeta-estado">{nombre.trim()}:</span>{' '}
                {telefonos[index] || 'N/A'}
              </p>
            ))}
          </div>
        )}

        {/* Si hay un solo asesor */}
        {!esVentas && nombresSeparados.length === 0 && name && telefonos && (
          <p className="tarjeta-nombre">
            <span className="bold-tarjeta-estado">{name.trim()}:</span>{' '}
            {telefonos[0] || 'N/A'}
          </p>
        )}
      </div>
    </div>
  );
};

export default React.memo(TarjetaEstado);
